<template>
  <div class="header">
    <nav class="nav container">
        <router-link
            v-for="(item, index) in menu"
            active-class="active"
            class="nav-item"
            :key="index"
            :to="item.path"
        >
          {{ item.name }}
        </router-link>

      <app-btn
          class="logout-btn"
          title="ВЫЙТИ"
          type="warning"
          @onClick="$emit('logout')"
      />
    </nav>
  </div>

</template>

<script>
import AppBtn from "@/components/AppBtn.vue";

export default {
  name: "MenuHeader",
  components: {AppBtn},
  data: () => ({
    menu: [
      {name: 'HR bot', path: '/hr-bot'},
      {name: 'Access to courses channel bot', path: '/access-to-courses-channel-bot'},
      {name: 'Send link to courses bot', path: '/send-course-link-bot'},
      {name: 'Affologize bot', path: '/affologize-bot'},
      {name: 'UAFF bot', path: '/uaff-hr-bot'},
    ]
  }),
}

</script>

<style scoped>
.header {
  background-color: #cde0c2;
  padding: 15px;
}

.nav {
  display: flex;
  gap: 15px;
}

.nav-item {
  display: block;
  height: 100%;
  padding: 0 10px;
  font-size: 18px;
  background-color: #fbfff8;
  border: 1px solid #cde0c2;
  border-radius: 4px;
  color: #021505;
  text-decoration: none;
}

.nav-item.active {
  background-color: #a1be93;
  color: white;
  border-color: #e0e8db;
}

.logout-btn {
  margin-left: auto;
  margin-right: 0;
}
</style>
